import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

interface RankChangeIndicatorProps {
  currentRank: number | null;
  previousRank: number | null;
  showValue?: boolean;
}

export const RankChangeIndicator = ({
  currentRank,
  previousRank,
  showValue = true,
}: RankChangeIndicatorProps) => {
  if (currentRank == null || previousRank == null) {
    return showValue ? (
      <span className="text-sm font-normal text-trend-neutral">0</span>
    ) : null;
  }

  const change = previousRank - currentRank;
  const isImproving = change > 0;
  const isDeclining = change < 0;
  const isStable = change === 0;

  return (
    <div
      className={cn(
        "flex items-center gap-1 text-sm font-normal",
        isImproving && "text-trend-positive",
        isDeclining && "text-trend-negative",
        isStable && "text-trend-neutral"
      )}
    >
      {isImproving && <TrendingUp className="h-4 w-4" />}
      {isDeclining && <TrendingDown className="h-4 w-4" />}
      {isStable && <Minus className="h-4 w-4" />}
      {showValue && (
        <span>
          {isImproving && "+"}
          {change}
        </span>
      )}
    </div>
  );
};
